import React from "react";
import LoanDashboardOverview from "./LoanDashboardOverview";
import DashboardLoanRequests from "./DashboardLoanRequests";

function LoanDashboardContents() {
  return (
    <div className="flex flex-col gap-4">
      <LoanDashboardOverview />
      <DashboardLoanRequests />
    </div>
  );
}

export default LoanDashboardContents;
